// src/components/MediaCard.js
// Image-forward Drift card: the media fills the card; a like chip sits top-right,
// and creator + Remix reveal on a gradient overlay at the bottom (on hover).

import Avatar from "./Avatar";

const fmt = (n = 0) => (n >= 1000 ? `${(n / 1000).toFixed(1)}k` : `${n}`);

export default function MediaCard({ post, onOpen, onLike, onRemix, onOpenCreator }) {
  const isVideo = post.type === "video";
  const media = post.thumbnail_url || post.media_url;
  const likes = post.likes_count ?? post.likes ?? 0;

  const stop = (fn) => (e) => {
    e.stopPropagation();
    fn();
  };

  return (
    <div className="mcard" onClick={() => onOpen(post)}>
      <div className="mcard__media">
        {media ? (
          <img src={media} alt={post.prompt || "drift post"} loading="lazy" />
        ) : (
          <div className="mcard__placeholder" />
        )}

        {isVideo && (
          <span className="mcard__badge">▶ {post.duration ? `0:${String(post.duration).padStart(2, "0")}` : "video"}</span>
        )}

        <button className="mcard__like" onClick={stop(() => onLike(post))} title="Like">
          ♥ {fmt(likes)}
        </button>

        <div className="mcard__overlay">
          <button
            className="mcard__creator"
            onClick={stop(() => (onOpenCreator ? onOpenCreator(post.creator_id) : onOpen(post)))}
          >
            <Avatar name={post.creator_username || "user"} url={post.creator_avatar_url} size={18} />
            <span>@{post.creator_username || "user"}</span>
          </button>
          <button className="mcard__remix" onClick={stop(() => onRemix(post))}>⟳ Remix</button>
        </div>
      </div>
    </div>
  );
}
